import React from 'react';
import { createPortal } from 'react-dom';
import { useParams } from 'react-router-dom';
import useTranslate from '../../../../common/hooks/useTranslate';

import { ICustomisationGuide } from '../../types/ICustomisationGuide';

import Icon from '../../../ui/icon/icon';

import './customisationGuide.scss';

const CustomisationGuide: React.FC<ICustomisationGuide> = ({
                                                             customisation,
                                                             resetCustomisation,
                                                             handleCustomisation,
                                                             handleReset,
                                                             handleCancel,
                                                             saveCustomisation,
                                                             noReset,
                                                           }) => {
  const { t } = useTranslate();
  const modalElement = document.getElementById('modal-root');
  const { boardId } = useParams();

  const handleOnReset = () => {
    resetCustomisation(boardId);
    handleReset(true);
    handleCustomisation(false);
  };

  const handleOnSave = () => {
    if (!noReset) {
      saveCustomisation(boardId);
      handleReset(false);
    } else {
      saveCustomisation();
    }
    handleCustomisation(false);
  };

  const handleOnCancel = () => {
    handleCancel && handleCancel();
    handleCustomisation(false);
  };

  return createPortal(
    customisation ? (
      <div id={'customisation-guide-wrapper'}>
        <div id={'customisation-guide'}>
          <h1>{!noReset ? t('WIDGET_EDIT_LAYOUT.TITLE') : t('WIDGET_EDIT_LAYOUT.TITLE_FOR_HOME_PAGE')}</h1>
          <p>
            {t('WIDGET_EDIT_LAYOUT.TEXT1')}
            <Icon name={'fa-solid fa-chevron-left'} />
            <Icon name={'fa-solid fa-chevron-right'} />
            {!noReset ? t('WIDGET_EDIT_LAYOUT.TEXT2') : t('WIDGET_EDIT_LAYOUT.TEXT2_FOR_HOME_PAGE')}
            {!noReset && <Icon name={'fas fa-times-circle'} />}
            {!noReset ? t('WIDGET_EDIT_LAYOUT.TEXT3') : t('WIDGET_EDIT_LAYOUT.TEXT3_FOR_HOME_PAGE')}
          </p>
          <div>
            {!noReset && <button className={'customisation-button customisation-reset pointer'} onClick={handleOnReset}>
              {t('WIDGET_EDIT_LAYOUT.RESET')}
            </button>}
            <button className={'customisation-button customisation-save pointer'} onClick={handleOnSave}>
              {t('WIDGET_EDIT_LAYOUT.SAVE')}
            </button>
            <button className={'customisation-button customisation-close pointer'} onClick={handleOnCancel}>
              {t('WIDGET_EDIT_LAYOUT.CLOSE')}
            </button>
          </div>
        </div>
      </div>
    ) : null,
    modalElement,
  );
};

export default CustomisationGuide;
